
function NotFound() {
  return (
    <div class>
      <h1>Page Not Found!!</h1>
    </div>
  );
}

export default NotFound